<style scoped>
.regra-personalizada__add {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}

.regra-personalizada__add select {
  font-size: 13px;
  border-radius: 6px;
  border: 1px solid #dddce9;
  padding: 8px 12px;
  background-color: #fff;
  min-width: 160px;
}

.regra-personalizada__add select:focus {
  border-color: #3a3e81;
  outline: none;
  box-shadow: 0 0 0 2px rgba(58, 62, 129, 0.1);
}

.button-add-regra {
  background: none;
  border: 1px dashed #3a3e81;
  border-radius: 8px;
  padding: 8px 20px;
  color: #3a3e81;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.button-add-regra:hover {
  background: #f2f2f8;
}
</style>

<template>
  <div>
    <div v-for="(dimensaoCampanha, index) in campanha.dimensoes" :key="index">
      <Segmento
          v-if="dimensaoCampanha.tipoRegra === 'SEGMENTACAO'"
          ref="segmento"
          :campanha="campanha"
          :dimensaoCampanha="dimensaoCampanha"
          :validacao="validacao"
          :dimensoes="dimensoes"
          :tiposInputs="tiposInputs"
          :index="index"
      />
      <Produto
          v-if="dimensaoCampanha.tipoRegra === 'PRODUTO'"
          :dimensaoCampanha="dimensaoCampanha"
          :campanha="campanha"
          :validacao="validacao"
          :tiposInputs="tiposInputs"
          :index="index"
      />
    </div>
    <div v-if="!campanha.erpId" class="regra-personalizada__add">
      <select v-model="regraSelecionada">
        <option value="SEGMENTACAO">Segmento</option>
        <option value="PRODUTO">Produto</option>
      </select>
      <button
          type="button"
          @click="adicionarRegra"
          class="button-add-regra"
      >
        + Adicionar Regra
      </button>
    </div>
  </div>
</template>

<script>
import Segmento from "./Segmento.vue";
import Produto from "./Produto.vue";

const initialDimensao = () => ({
  dimensao1: "",
  dimensao2: "",
  dimensao3: "",
  dimensao4: "",
  dimensao5: "",
  dimensao6: "",
  dimensao7: "",
  dimensao8: "",
  dimensao9: "",
  dimensao10: "",
  dimensaoaplicacao1: "",
  dimensaoaplicacao2: "",
  dimensaoaplicacao3: "",
  dimensaoaplicacao4: "",
  dimensaoaplicacao5: "",
  dimensaoaplicacao6: "",
  dimensaoaplicacao7: "",
  dimensaoaplicacao8: "",
  dimensaoaplicacao9: "",
  dimensaoaplicacao10: "",
  percDesc: 0,
  aplicaregra: true,
  qtdeMin: 0,
  qtdeMax: null,
  qtdeMinDistinta: 0,
  qtdeMaxDistinta: null,
  vlMin: 0,
  vlMax: 0,
  percMin: 0,
  percMax: 0,
  tipoRegra: 'SEGMENTACAO'
});

const initialProduto = () => ({
  idProd: null,
  idProdAplicacao: null,
  idProdPrincipal: null,
  idProdPrincipalAplicacao: null,
  percDesc: 0,
  aplicaregra: true,
  qtdeMin: 0,
  qtdeMax: null,
  qtdeMinDistinta: 0,
  qtdeMaxDistinta: null,
  vlMin: 0,
  vlMax: 0,
  percMin: 0,
  percMax: 0,
  tipoRegra: 'PRODUTO'
});

  export default {
    components: {Segmento, Produto},
    props: ['campanha', 'validacao', 'dimensoes', 'tiposInputs'],
    data() {
      return {
        regraSelecionada: 'SEGMENTACAO',
        dimensao: initialDimensao(),
      }
    },
    methods: {
      adicionarRegra() {
        if (this.regraSelecionada === 'SEGMENTACAO') {
          this.campanha.dimensoes.push(initialDimensao());
        }
        if (this.regraSelecionada === 'PRODUTO') {
          this.campanha.dimensoes.push(initialProduto())
        }
      }
    }
  }
</script>
